import { Button, Link } from '@vp/swan';
import { useTrackNavigationClicked } from '../../../../utils/analytics';
import { toSentenceCase } from '../../../../utils/helper';
import { logoInspirationKeywordPath } from '../../../../utils/urls';

interface RelatedIdeasLinkProp {
    currentKeyword?: string;
    keyword: string;
    name: string;
}

const RelatedIdeasLink = ({ currentKeyword, keyword, name }: RelatedIdeasLinkProp) => {
    const relatedKeywordRef = useTrackNavigationClicked(
        'Logo Ideas',
        currentKeyword
            ? `Logo Inspiration Keyword Page - ${currentKeyword}`
            : 'Logo Inspiration Root Page',
        logoInspirationKeywordPath(keyword),
        'discoverLogos',
    );
    return (
        <Button
            width="full-width"
            render={(props) => (
                <Link
                    to={logoInspirationKeywordPath(keyword)}
                    className={props.className}
                    ref={relatedKeywordRef}
                >
                    {props.children}
                </Link>
            )}
        >
            {`${toSentenceCase(name)} logo ideas`}
        </Button>
    );
};

export default RelatedIdeasLink;
